import { Fragment } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { classNames } from "../../../utils/utils";
import { useTheme } from "../../../utils/themeUtils";
import { CancelIcon } from "../../../utils/iconFactory";
import { PrimaryButton, TertiaryButton } from "../../Elements/CustomButtons";

export function LoadDocumentModal({ isVisible, onClose, execute }: { isVisible: boolean; onClose: () => void, execute: () => void }){
  const { themeString } = useTheme()
  
  return (
    <Transition appear show={isVisible} as={Fragment}>
      <Dialog as="div" className={classNames("relative z-40", themeString)} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative h-[380px] w-[560px] rounded-[22px] bg-backgroundWhite py-8 text-left align-middle transform transition-all overflow-hidden modal-shadow">
                <Dialog.Title
                  as="h3"
                  className="text-textMain text-style-h3 border-b border-gray10 pb-4 mx-8 overflow-hidden"
                >
                  Dokumentumok
                </Dialog.Title>
                <button className='absolute top-9 right-6' onClick={onClose}>
                  <CancelIcon className='h-6 w-6 text-gray100 fill-current' />
                </button>

                <div id='content' className="flex flex-col max-h-full gap-4 px-8 pt-6 overflow-y-auto no-scrollbar">
                  <p className="text-textMain text-style-body2">Az eddigi beállításaid elvesznek, ha egy korábbi dokumentumot szeretnél betölteni.</p>
                  <p className="text-textMain text-style-body2-bold">Biztosan betöltesz egy korábbi dokumentumot?</p>
                  <div id="buttons" className='flex flex-col gap-4 pt-8'>
                    <PrimaryButton buttonInfo={{label: "Igen, betöltöm"}} onClick={() => {execute(); onClose();}} />
                    <TertiaryButton buttonInfo={{label: "Mégsem"}} onClick={onClose} />
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}